const base = {
  default: {
    height: '100%',
    '& > img': {
      height: '25px',
      maxWidth: '100%'
    },
    '& > a': {
      color: 'coolGrey.100'
    },
    '& > ol': {
      height: 'inherit',
      alignItems: 'center',
      marginBlock: 0,
      paddingInline: 0
    }
  }
};

const press = {
  default: {
    height: '100%',
    margin: 0,
    marginRight: '21px',
    maxHeight: '35px',
    '& img': {
      height: '35px',
      maxWidth: '100%'
    },
    '& > a': {
      color: 'coolGrey.100'
    },
    '& > ol': {
      height: 'inherit',
      alignItems: 'center',
      marginBlock: 0,
      paddingInline: 0
    }
  }
};

const brand = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default brand;
